import { render, staticRenderFns } from "./ketohc.vue?vue&type=template&id=1ea353f4&scoped=true&"
import script from "./ketohc.vue?vue&type=script&lang=js&"
export * from "./ketohc.vue?vue&type=script&lang=js&"
import style0 from "./ketohc.vue?vue&type=style&index=0&id=1ea353f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea353f4",
  null
  
)

export default component.exports